import { defineConfig as e } from "cva";
import { extendTailwindMerge as t } from "tailwind-merge";
const s = t({
  extend: {
    classGroups: {
      "font-size": ["text-3xs", "text-xxs"]
    }
  }
}), { cva: i, cx: r, compose: c } = e({
  hooks: {
    onComplete: (o) => s(o)
  }
});
export {
  c as compose,
  i as cva,
  r as cx,
  s as tw
};
